import * as React from "react";
import { DefaultHtmlAttributes } from "@syncfusion/ej2-react-base";
import { LoadingButtonProps } from "./useLoadingButton";
import LoadingButton from "./LoadingButton";
import { UCLColors, UCLColorKey } from "../colors/uclColors";

export const PrimaryButtonStyle: Pick<
  LoadingButtonProps,
  | "buttonClassStyle"
  | "defaultLoadingIdleContent"
  | "defaultLoadingProgressContent"
  | "defaultLoadingSuccessContent"
  | "cssClass"
> & {
  style: {
    background: string;
    borderColor: string;
    color: string;
  };
} = {
  buttonClassStyle: "e-primary",
  defaultLoadingIdleContent: "Save",
  defaultLoadingProgressContent: "Saving",
  defaultLoadingSuccessContent: "Saved",
  cssClass: "ucl-primary-button",
  style: {
    background: UCLColors["sky-blue"],
    borderColor: UCLColors["sky-blue"],
    color: "#fff",
  },
};

export interface PrimaryButtonProps
  extends Omit<
    LoadingButtonProps,
    | "buttonClassStyle"
    | "defaultLoadingIdleContent"
    | "defaultLoadingProgressContent"
    | "defaultLoadingSuccessContent"
  > {
  color?: UCLColorKey;
}

/**Default 'Save' button with primary styling*/
const PrimaryButton: React.FC<
  PrimaryButtonProps & Readonly<DefaultHtmlAttributes>
> = (props) => {
  // Use color prop as UCLColorKey, otherwise undefined
  const resolvedColor = props.color ? UCLColors[props.color] : undefined;

  return (
    <LoadingButton
      {...PrimaryButtonStyle}
      {...props}
      cssClass={props.cssClass + " ucl-primary-button"}
      style={
        resolvedColor
          ? {
              background: resolvedColor,
              borderColor: resolvedColor,
              color: "#fff",
              ...(props.style || {}),
            }
          : props.style
      }
    />
  );
};
export default PrimaryButton;
